import _styled from "styled-components";
var _excluded = ["Icon", "active", "brandColorMode", "displayBorder", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ButtonInner } from "../ButtonInner/ButtonInner";
import * as styles from "./styles";
var ICON_BUTTON_SIZE_MAP = {
  small: 16,
  large: 24
};

/**
 * IconButton takes an icon component as a prop and returns a rounded button with the centered icon
 */
export var IconButton = function IconButton(_ref) {
  var Icon = _ref.Icon,
    active = _ref.active,
    brandColorMode = _ref.brandColorMode,
    displayBorder = _ref.displayBorder,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconSize = ICON_BUTTON_SIZE_MAP[size];
  var getIconColor = function getIconColor() {
    if (props.disabled) {
      return 'var(--neutral-black-70)';
    }
    if (brandColorMode) {
      return 'var(--brand-purple-base)';
    }
    return undefined;
  };
  return /*#__PURE__*/React.createElement(_StyledButton, _extends({
    "data-is-active": active
  }, props, {
    $_css: [size === 'small' ? styles.small : styles.large, styles.iconButton, brandColorMode && styles.brandStyles, displayBorder && styles.borderStyles]
  }), /*#__PURE__*/React.createElement(ButtonInner, null, /*#__PURE__*/React.createElement(Icon, {
    color: getIconColor(),
    height: iconSize,
    width: iconSize
  })));
};
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "IconButton___StyledButton",
  componentId: "sc-1awjtwc-0"
})(["", ""], function (p) {
  return p.$_css;
});